import React, { useState, useEffect } from "react";

function Messages({ data, messages, setMessages }) {

  const messageTypes = {
    plan: "Creating a plan",
    browse: "Browsing the web",
    write_code: "Writing the code",
    run_code: "Executing the code",
    assess: "Assessing the results",
    success: "Task completed successfully",
    fail: "Task failed",
    quit: "Quitting the task"
  };

  const getMessageStyle = (type) => {
    switch (type) {
      case "plan":
      case "write_code":
      case "run_code":
      case "assess":
      case "browse":
        return { backgroundColor: "var(--secondary-color)", color: "white" };
      case "success":
        return { backgroundColor: "lightgreen", color: "black" };
      case "fail":
        return { backgroundColor: "red", color: "white" };
      case "quit":
        return { backgroundColor: "lightcoral", color: "white" };
      default:
        return { backgroundColor: "white", color: "black" };
    }
  };

  useEffect(() => {
    if (data) {
      setMessages((prevMessages) => [...prevMessages, data]);
    }
  }, [data]);

  return (
    <div className="messages">
      <h2 className="otherhead" style={{fontStyle: "italic"}}>Thinking...</h2>
      {messages.map((message, index) => (
        <div
          key={index}
          style={{
            border: "1px solid black",
            padding: "10px",
            margin: "10px 0",
            ...getMessageStyle(message.notify_type),
          }}
        >
          {message.notify_type === "browse" && message.content ? message.content : messageTypes[message.notify_type]}
        </div>
      ))}
    </div>
  );
}

export default Messages;
